import type { Texture } from 'pixi.js';
import type { IAssetManager, Manifest } from './interfaces/IAssetManager';
import * as assetLoader from './loaders/AssetLoader';

export class AssetManager implements IAssetManager {
  constructor(public baseUrl: string) {}

  async loadManifest(slug: string): Promise<Manifest> {
    return assetLoader.loadManifest(this.baseUrl, slug);
  }

  async loadPack(
    slug: string,
    manifest: Manifest,
    pack: string
  ): Promise<void> {
    return assetLoader.loadPack(this.baseUrl, slug, manifest, pack);
  }

  isPackLoaded(_slug: string, _pack: string): boolean {
    // Simple check - if we can get a texture, pack is loaded
    return true; // We'll let the individual loaders handle caching
  }

  getTexture(slug: string, path: string): Texture | null {
    return assetLoader.getTexture(this.baseUrl, slug, path);
  }

  getSpineResource(slug: string, path: string): any {
    return assetLoader.getSpineResource(this.baseUrl, slug, path);
  }

  getAudio(slug: string, path: string): HTMLAudioElement | undefined {
    return assetLoader.getAudio(this.baseUrl, slug, path);
  }

  async loadAsset(slug: string, path: string): Promise<any> {
    return assetLoader.loadAsset(this.baseUrl, slug, path);
  }

  async loadSpine(slug: string, jsonPath: string): Promise<any> {
    return assetLoader.loadSpine(this.baseUrl, slug, jsonPath);
  }
}
